import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import TaskManagementSidebar from "./TaskManagementSidebar";
import Navbar from "../../../layout/Navbar";
import CreateTaskModal from "../../../components/CreateTaskModal";
import { getUser } from "../../../config/auth";
import { canCreateTask } from "../../../config/rbac";

function TaskManagementLayout() {
  const [showCreateTask, setShowCreateTask] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const location = useLocation();
  const user = getUser();
  const role = user?.role || "Member";
  const allowCreate = canCreateTask(role);

  const openCreate = () => {
    if (!allowCreate) return;
    setShowCreateTask(true);
  };

  return (
    <div className="app-shell">
      <TaskManagementSidebar
        onCreateTask={openCreate}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="app-main">
        <Navbar onCreateTask={openCreate} onMenuToggle={() => setSidebarOpen(o => !o)} />

        <main className="app-content">
          <div key={location.pathname} className="content-inner page-enter">
            <Outlet context={{ refreshKey }} />
          </div>
        </main>
      </div>

      {allowCreate && (
        <CreateTaskModal
          open={showCreateTask}
          onClose={() => setShowCreateTask(false)}
          onCreated={() => setRefreshKey((k) => k + 1)}
        />
      )}
    </div>
  );
}

export default TaskManagementLayout;
